module.exports = "/_next/static/images/SyncData-fc6bfb47cd3c77c7ae8a40c2dcc091a5.webp";